export default {
  screens: [
    {
      type: 'intro',
      title: 'Le choix des souverains',
      content:
        "Surprenante entremetteuse, la tiare du pape Pie VII est à l'origine de la rencontre entre Chaumet et Joséphine.",
      idYt: 'q7zuNJ10apM',
      videoCover: 'world/sovereign/video.jpg',
      desktop: {
        cover: 'world/sovereign/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sovereign/mobile-cover-1.jpg',
        contentStyle: { width: '70%' },
        coverStyle: {
          width: '110%',
          top: '90%',
          left: '15%',
          position: 'absolute'
        }
      },
      isBottom: true
    },
    {
      type: 'columnVideo',
      content:
        'Le plus important des cadeaux diplomatiques offerts par Napoléon, la tiare de Pie VII est exécutée à la demande de l’empereur, en remerciement de la venue du souverain pontife pour son Sacre le 2 décembre 1804 à Notre-Dame de Paris.',
      idYt: 'O-1TKgKxDdg',
      videoCover: 'world/sovereign/video-2.jpg',
      cover: 'world/sovereign/cover-2.jpg',
      isBottom: true
    },
    {
      type: 'video',
      middleImg: 'world/sovereign/tiare.jpg',
      videoBlock: {
        cover: 'world/sovereign/video-3.jpg',
        idYt: '5ExHUFrxFms'
      },
      content:
        'A l’occasion de cette exposition, le Vatican a confié à Chaumet la restauration de la tiare et la création d’une nouvelle croix pour surmonter son exceptionnelle émeraude sommitale.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/fr/worlds/sovereign.js